let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gdahJ")).then(() => parcelRequire('8MQQx'));